export type TileKind =
  | 'shield'
  | 'claws'
  | 'repulsor'
  | 'web'
  | 'hammer'
  | 'fist'
  | 'eye'
  | 'hex'
  | 'photon'
  | 'gem'
  | 'atom'
  | 'ghost-web'
  | 'bolt'
  | 'adamantium'
  | 'blaster'
  | 'billyclub'
  | 'flame'
  | 'power-sword'
  | 'dragon-dagger'
  | 'power-bow'
  | 'red'
  | 'blue'
  | 'green'
  | 'yellow'
  | 'purple';

export const COLS = 6;
export const ROWS = 7;

export type TileId = number;

export type Tile = {
  id: TileId;
  kind: TileKind;
  bomb?: boolean;
  portal?: boolean;
  gravity?: boolean;
};

export type Cell = { row: number; col: number };

export type Grid = (Tile | null)[][];

export type Match = {
  cells: Cell[];
  kind: TileKind;
};
